module.exports = __webpack_public_path__ + "img/secure-payments.e74f029c.jpg";